import {  useNavigate } from "react-router-dom";
import { tokens } from "../../../styles/theme";
import Header from "../../../components/Header";
import { getAllFund } from "../../../services";
import React, { useEffect, useState } from "react";
import { Box, useTheme, Button } from "@mui/material";
import Container from "./Container";
import * as sweetalert from "sweetalert";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import axios from "axios";
import ConfirmDialog from "../global/ConfirmDialog";
import {
  DataGridPro,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarExport,
} from "@mui/x-data-grid-pro";
import PropTypes from "prop-types";
import packageJson from "../../../../package.json";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
function EditToolbar(props) {
  return (
    <>
      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
        <GridToolbarExport csvOptions={{
          fileName: "الأرصدة",
          utf8WithBom: true,
        }}/>
      </GridToolbarContainer>
    </>
  );
}
EditToolbar.propTypes = {
  setRowModesModel: PropTypes.func.isRequired,
};

const Fund = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [users, setUsers] = useState([]);
  const [r, setr] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [rowModesModel, setRowModesModel] = React.useState({});
  const [rows, setRows] = React.useState();
  const [fundname, setfundName] = React.useState();
  const [id, setfundId] = React.useState([]);
  const [fundtype, setfundType] = React.useState();
  const [fundtype1, setfundType1] = React.useState();
  const [fundtype2, setfundType2] = React.useState();
  const [fundtype3, setfundType3] = React.useState();
  const [fundtype4, setfundType4] = React.useState();
  const [fundcompany, setfundCompany] = React.useState([]);
  const [pricegeneral, setPriceGeneral] = React.useState([]);
  const [priceprivate, setPricePrivate] = React.useState([]);
 
  useEffect(() => {
    setIsLoading(true);
    getAllFund()
      .then((res) => {
        setUsers(res.data);

        setIsLoading(false);
        setfundType(
          res.data.map((n) => ({
            ...id,
            ["p"]: { id: n.id, fund_name: n.fund_name },
          }))
        );
        setfundType1(
          res.data.map((n) => ({
            ...id,
            ["p"]: { id: n.id, fund_type: n.fund_type },
          }))
        );
        setfundType2(
          res.data.map((n) => ({
            ...id,
            ["p"]: { id: n.id, fund_company: n.fund_company },
          }))
        );
        setfundType3(
          res.data.map((n) => ({
            ...id,
            ["p"]: {
              id: n.id,
              price_for_general_distributor: n.price_for_general_distributor,
            },
          }))
        );
        setfundType4(
          res.data.map((n) => ({
            ...id,
            ["p"]: {
              id: n.id,
              price_for_special_distributor: n.price_for_special_distributor,
            },
          }))
        );
      })
      .catch((err) => {
        setUsers([]);
        setIsLoading(false);
      });

    return () => {};
  }, []);
  const handleView = (id) => () => {
    navigate(`/lirtna-percentage/${id}`, { state: { id: id } });
  };
  const handleView2 = (id) => () => {
    navigate(`/bill-percentage/${id}`, { state: { id: id } });
  };
  const handleRowEditStart = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  const handleRowEditStop = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  const processRowUpdate = (newRow) => {
    const updatedRow = { ...newRow, isNew: false };
    setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));
    return updatedRow;
  };
  const handleViewValue = (id,company,fund_name) => () => {
    navigate(`/viewValue/${id}`, { state: { id: id ,company: company,fundnamecompany:fund_name} });
  };
  const handleD = (id) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
    axios
      .delete(`${BaseUrl}/api/deleteFund/${id}`, {
        withCredentials: true,
      })
      .then((res) => {
        if (res.status === 200) {
          sweetalert("تمت العملية بنجاح", {
            className: "alert-div",
            button: {
              text: "تم",
            },
          });

          setUsers(users.filter((row) => row.id !== id));
        } else {
          sweetalert("هذا المستخدم غير موجود", {
            className: "alert-div",
            button: {
              text: "تم",
            },
          });
        }
      })
      .catch((err) => {});
  };

  const columns = [
    {
      field: "fund_name",
      headerName: "اسم الرصيد",
      headerAlign: "center",
      align: "center",
      flex: 1,
      cellClassName: "name-column--cell",
      editable: false,
    },
    {
      field: "fund_type",
      headerName: "النوع",
      type: "number",
      headerAlign: "center",
      align: "center",
      flex: 1,
      editable: false,
      renderCell: (params) => {
        const isActive = params.value;
        return isActive === "Leritna" ? (
          <p style={{ color: "#403e3e", fontSize: "15px" }}>ليرتنا</p>
        ) : isActive === "Cache" ? (
          <p style={{ color: "#403e3e", fontSize: "15px" }}>كاش</p>
        ) : isActive === "Bills" ? (
          <p style={{ color: "#403e3e", fontSize: "15px" }}>فواتير</p>
        )  : isActive === "Units" ?  (
          <p style={{ color: "#403e3e", fontSize: "15px" }}>وحدات</p>
        ):(
          <p style={{ color: "#403e3e", fontSize: "15px" }}></p>
        )
      },
    
    },
    {
      field: "fund_company",
      headerName: "اسم الشركة",
      headerAlign: "center",
      align: "center",
      editable: false,
    },

    {
      field: "actions",
      type: "actions",
      headerName: "اجراءات",
      headerAlign: "center",
      align: "center",
      flex: 2,

      cellClassName: "actions",
      renderCell: (id) => {
        if (id.row.fund_type === "Bills") {
          return (
            <Box className="editbtn">
              <Container
                triggerText={<EditIcon />}
                text1={"تعديل"}
                fundname={fundname}
                id={id.row.id}
                fundtype={fundtype}
                fundtype1={fundtype1}
                fundtype2={fundtype2}
                fundtype3={fundtype3}
                fundtype4={fundtype4}
                fundcompany={fundcompany}
                pricegeneral={pricegeneral}
                priceprivate={priceprivate}
              />

              <Button
                variant="contained"
                color="primary"
                className="viewbtn"
                onClick={handleView2(id.row.id)}
              >
                %
              </Button>

              <Button
                variant="contained"
                color="primary"
                className="viewbtn"
                onClick={() => {
                  setConfirmDialog({
                    isOpen: true,
                    title: "هل تريد حذف هذه السجل؟",
                    subTitle: "لايمكن التراجع عن هذه العملية",
                    onConfirm: () => {
                      handleD(id.row.id);
                    },
                  });
                }}
              >
                <DeleteIcon />
              </Button>
              <ConfirmDialog
                confirmDialog={confirmDialog}
                setConfirmDialog={setConfirmDialog}
              />
            </Box>
          );
        }
        if (id.row.fund_type === "Units" || id.row.fund_type === "Cache") {
          return (
            <Box className="editbtn1">
              <Container
                triggerText={<EditIcon />}
                text1={"تعديل"}
                fundname={fundname}
                id={id.row.id}
                fundtype={fundtype}
                fundtype1={fundtype1}
                fundtype2={fundtype2}
                fundtype3={fundtype3}
                fundtype4={fundtype4}
                fundcompany={fundcompany}
                pricegeneral={pricegeneral}
                priceprivate={priceprivate}
              />
              <Container
                triggerText={<AddIcon />}
                fundname={fundname}
                id={id.row.id}
                company={id.row.fund_company}
                fundtype={fundtype}
                fundtype1={fundtype1}
                fundtype2={fundtype2}
                fundtype3={fundtype3}
                fundtype4={fundtype4}
                fundcompany={fundcompany}
                pricegeneral={pricegeneral}
                priceprivate={priceprivate}
                className="viewbtn"
              />
              <Button
                variant="contained"
                color="primary"
                className="viewbtn"
                onClick={handleViewValue(id.row.id,id.row.fund_company,id.row.fund_name)}
              >
                <VisibilityIcon />
              </Button>
              <Button
                variant="contained"
                color="primary"
                className="viewbtn"
                onClick={() => {
                  setConfirmDialog({
                    isOpen: true,
                    title: "هل تريد حذف هذه السجل؟",
                    subTitle: "لايمكن التراجع عن هذه العملية",
                    onConfirm: () => {
                      handleD(id.row.id);
                    },
                  });
                }}
              >
                <DeleteIcon />
              </Button>
              <ConfirmDialog
                confirmDialog={confirmDialog}
                setConfirmDialog={setConfirmDialog}
              />
              ,
            </Box>
          );
        }
        if (id.row.fund_type === "Leritna") {
          return (
            <Box className="editbtn1">
              <Button
                variant="contained"
                color="primary"
                className="viewbtn"
                onClick={handleView(id.row.id)}
              >
                %
              </Button>
              <Container
                triggerText={<EditIcon />}
                text1={"تعديل"}
                fundname={fundname}
                id={id.row.id}
                fundtype={fundtype}
                fundtype1={fundtype1}
                fundtype2={fundtype2}
                fundtype3={fundtype3}
                fundtype4={fundtype4}
                fundcompany={fundcompany}
                pricegeneral={pricegeneral}
                priceprivate={priceprivate}
              />
              <Button
                variant="contained"
                color="primary"
                className="viewbtn"
                onClick={() => {
                  setConfirmDialog({
                    isOpen: true,
                    title: "هل تريد حذف هذه السجل؟",
                    subTitle: "لايمكن التراجع عن هذه العملية",
                    onConfirm: () => {
                      handleD(id.row.id);
                    },
                  });
                }}
              >
                <DeleteIcon />
              </Button>
              <ConfirmDialog
                confirmDialog={confirmDialog}
                setConfirmDialog={setConfirmDialog}
              />
              ,
            </Box>
          );
        }
      },
    },
  ];

  return (
    <Box m="2px 5px 0px 5px">
      <Header
      />

      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.redAccent[1100],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.redAccent[1100],
            borderBottom: "none",
            fontSize: "10px !important",
          },
          "& .MuiDataGrid-cellContent": {
            fontSize: "10px !important",
            color: `${colors.grey[600]} !important`,
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.white[100],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.redAccent[1100],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
        }}
      >
        <DataGridPro
          rows={users}
          columns={columns}
          className="field-table"
          editMode="row"
          pageSize={10}
          pagination
          rowModesModel={rowModesModel}
          onRowModesModelChange={(newModel) => setRowModesModel(newModel)}
          onRowEditStart={handleRowEditStart}
          onRowEditStop={handleRowEditStop}
          processRowUpdate={processRowUpdate}
          components={{
            Toolbar: EditToolbar,
          }}
          localeText={{
          toolbarColumns: "الأعمدة",
          toolbarFilters: "الفلاتر",
          toolbarDensity: "التباعد",
          toolbarExport: "تصدير",
          filterPanelAddFilter:'إضافة فلتر',
          filterOperatorContains:'تحتوي',
          filterOperatorEquals:'تساوي',
          filterOperatorStartsWith:'تبدأ ب',
          filterOperatorEndsWith:'تنتهي  ب',
          filterOperatorIsAnyOf:'هو أي من',
          filterOperatorIsEmpty:'فارغ',
          filterOperatorIsNotEmpty:'غير فارغ',
          toolbarDensityCompact:'دمج',
          toolbarDensityStandard:'معيار',
          toolbarDensityComfortable:'مريح',
          toolbarExportCSV:'تصدير CSV',
          toolbarExportPrint:'طباعة',
          filterPanelInputLabel:'القيمة',
          filterPanelInputPlaceholder:"ادخل القيمة",
          filterPanelColumns:'الاعمدة',
          filterPanelOperators:'العمليات',
          columnsPanelTextFieldLabel:'بحث عن عمود',
          columnsPanelTextFieldPlaceholder:'عنوان العمود',
        }}
          componentsProps={{
            toolbar: { setRows, setRowModesModel },
          }}
          experimentalFeatures={{ newEditingApi: true }}
        />
      </Box>
    </Box>
  );
};

export default Fund;
